// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".runtime[data-v-53a6db72]{position:absolute;bottom:60px;text-align:center;width:100%;cursor:pointer}.runtime i[data-v-53a6db72]{font-size:2.5em}", ""]);
// Exports
module.exports = exports;
